import { render, staticRenderFns } from "./AdviserScoreRecord.vue?vue&type=template&id=4a8e21d5&scoped=true"
import script from "./AdviserScoreRecord.vue?vue&type=script&lang=js"
export * from "./AdviserScoreRecord.vue?vue&type=script&lang=js"
import style0 from "./AdviserScoreRecord.vue?vue&type=style&index=0&id=4a8e21d5&prod&scoped=scoped&lang=css"
import style1 from "./AdviserScoreRecord.vue?vue&type=style&index=1&id=4a8e21d5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8e21d5",
  null
  
)

export default component.exports